import React from "react"

function Card({index, imgSrc, title, altText, description}) {
    return (
        <div className="features-card-item features-card-item-fixed contentMarker" data-marker-content="import">
            <img src={imgSrc} alt={altText}/>
            <h1>{index + 1}</h1>
            <h3>{title}</h3>
            <p>{description}
            </p>
        </div>
    )
}


export default function WrapSodyMobileScroll({data}) {

    const {scrollComponent} = data

    return (
        <div className="section">
            <section className="our-best-features-wrapper">
                <div className="container">
                    {scrollComponent && scrollComponent.map(((itm, index) =>
                            <Card
                                index={index}
                                imgSrc={itm?.image?.url}
                                title={itm?.title}
                                altText={itm?.altText}
                                description={itm?.description}
                            />
                    ))}
                </div>
            </section>
        </div>
    )
}
